// extracted by mini-css-extract-plugin
export default {"header":"header_header__x8oeZ","navbar":"header_navbar__dWZRb","text":"header_text__6sUMp"};